var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9a.75.75 0 0 1-.75-.75v-4.5c0-.415.334-.75.75-.75s.75.335.75.75v2.503l.625-.734A6.98 6.98 0 0 1 10.25 3a7 7 0 1 1-4.2 12.6.75.75 0 0 1-.15-1.05.75.75 0 0 1 1.05-.15 5.5 5.5 0 1 0-.925-7.919l-.003.007L5.159 7.5H8c.416 0 .75.335.75.75 0 .416-.334.75-.75.75z"
  })));
};
export default SvgUndo;